export default "__VITE_ASSET__CaVFGbZy__"